export const demoData = {
  version: 1.0,
  title: "NICE Demo",
  flows: [
    {
      id: 0,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 1,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Automatically record omnichannel interactions in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: [""],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "With NICE Compliance Recording integrated in Teams, all interactions between regulated users, employees, and customers are securely recorded and stored.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "77.5%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step1a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The view begins in a chat window, with a thread between Megan Bowen and Nestor Wilke. The chat begins with Megan. Her message reads “Hi Nestor! Do you have time for a quick call to debrief on that last meeting?” Nestor replies “Sure, go head and give me a call.”",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Begin a call in Teams with an internal employee or external customer",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6.05%",
              x: "90.28%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step1a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The view begins in a chat window, with a thread between Megan Bowen and Nestor Wilke. The chat begins with Megan. Her message reads “Hi Nestor! Do you have time for a quick call to debrief on that last meeting?” Nestor replies “Sure, go head and give me a call.”",
        },
        {
          id: 3,
          card: {
            transition: false,
            text:
              "A bot will enter the conversation to record the interaction, creating two copies for added resiliency.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82.5%",
              x: "90.28%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step1a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The view begins in a chat window, with a thread between Megan Bowen and Nestor Wilke. The chat begins with Megan. Her message reads “Hi Nestor! Do you have time for a quick call to debrief on that last meeting?” Nestor replies “Sure, go head and give me a call.”",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "Leave the video call when the meeting is over, and the recording will soon be available in the NICE Compliance Assurance (COMPASS) Portal.",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "90.5%",
              x: "60.15%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["NICE_Step1a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to an icon to end the call.",
        },
        {
          id: 5,
          card: {
            transition: false,
            text:
              "NICE Compliance Recording also automatically archives chat conversations, voice calls, and screen sharing among regulated users.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "60.15%",
            },
            beacon: {
              isVisible: false,
              position: "bottom",
            },
          },
          images: {
            name: ["NICE_Step1a_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The call between Megan and Nestor had ended, and the view has returned to their chat window.",
        },
      ],
    },
    {
      id: 2,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Manage recorded communications in the NICE COMPASS Portal",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step0_Title_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "NICE provides efficient communication recording, archiving, and management that compliance officers require in highly regulated industries, such as financial services and healthcare.",
            snack: {
              isVisible: true,
              position: "right",
            },
            position: {
              y: "75.5%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The view has switched to the NICE login screen. The page is a blue and black pattern with the NICE logo. There are two fields: User Name and Password.",
        },
        {
          id: 2,
          card: {
            transition: false,
            text: "Log in to the NICE COMPASS Portal",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "47.9%",
              x: "46%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to the User Name field.",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "56.5%",
              x: "57.6%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: true,
            sequenceSources: [
              "NICE_Step2a_Image1.jpg",
              "NICE_Step2a_Image2b.jpg",
              "NICE_Step2a_Image2c.jpg",
              "NICE_Step2a_Image2d.jpg",
              "NICE_Step2a_Image2e.jpg",
              "NICE_Step2a_Image2f.jpg",
              "NICE_Step2a_Image2g.jpg",
              "NICE_Step2a_Image2h.jpg",
              "NICE_Step2a_Image2i.jpg",
              "NICE_Step2a_Image2j.jpg",
              "NICE_Step2a_Image2k.jpg",
            ],
          },
          screenReaderText:
            "Screen reader text: In the same view, the user has entered compliance@contoso.com in the user name field, as well as a password.",
        },
        {
          id: 4,
          card: {
            transition: false,
            text:
              "The COMPASS advanced filtering helps users narrow search criteria to find recorded interactions across voice, video, screensharing, chat, and email.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "78%",
              x: "57.6%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The view has changed to the NICE filtering page. A purple box outlines a vertically oriented filtering menu. It reads top to bottom “Filters, clear selections, users, time period, litigation hold, call direction, call duration, interaction type, interaction type, interaction status, recording system. remarks, call properties, participants, advanced call properties. ",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Click “Interaction Type”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "25%",
              x: "2.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "Screen reader text: In the same view, a purple pop-up points to “interaction type” in the menu. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "Select “Video”",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "33%",
              x: "1.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A vertically oriented menu has expanded below “interaction type”. A purple pop-up points to “video”",
        },
        {
          id: 7,
          card: {
            transition: false,
            text: "Click the Search button to see results",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92.6%",
              x: "7.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a “Search” button below the menu. ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Choose the call you would like to replay",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "26%",
              x: "18.2%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image8.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "To the right side of the menu a list of video calls has appeared. A purple pop-up points to the fourth call on the list between Megan Bowen and Nestor Wilke. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "View detailed information about the call including participants and metadata",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "32%",
              x: "38.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked on the call between Megan Bowen and Nestor Wilke. The list of calls has moved to the left side of the windows, and details of the call are now listed on the right. A purple box outlines the call details. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text:
              "NICE Compliance Recording assesses recording quality through the Voice metric. If the metric is below an established threshold, an alarm will notify technical or operations teams of playback issues.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "75%",
              x: "38.5%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText: "",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Click the play button to replay the recorded interaction",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "92%",
              x: "54.1%",
            },
            beacon: {
              isVisible: true,
              position: "bottom",
            },
          },
          images: {
            name: ["NICE_Step2a_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a play button icon at the bottom of the screen that will replay the call. ",
        },
        {
          id: 10,
          card: {
            transition: false,
            text: "Close the pop-up window when finished reviewing",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "6%",
              x: "96.1%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step2a_Image12.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "A new window has appeared that will playback the call between Megan Bowen and Nestor Wilke. ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text:
              "Export the recording and call data by clicking the checkbox in the left toolbar",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "26%",
              x: "0.1%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image13.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The playback window has been closed, and the view has returned to the call details between Megan Bowen and Nestor Wilke. A purple pop-up points to a check box next to the Megan Bowen and Nestor Wilke call within the list on the left side.",
        },
        {
          id: 12,
          card: {
            transition: false,
            text:
              "Select the download icon to export XML, WAV, and MP4 files of the interaction",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "4.6%",
              x: "3%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image15.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a download icon in the upper left-hand corner of the screen ",
        },
        {
          id: 13,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "54.8%",
              x: "56.7%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image16.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the user has clicked the download icon and a notification has popped up in the middle of the screen letting the user know the report is 100% downloaded. A purple pop-up is pointing to a button that reads “Done”.  ",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "Choose the CSV icon to download a file with call metadata",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "4.5%",
              x: "4.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the notification has disappeared, and a purple pop-up is pointing to a CSV icon to the right of the download icon. ",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "Use the lock icon to place a hold on an interaction",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "4.5%",
              x: "1.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the purple pop-up is now pointing to a lock icon to the left of the CSV icon. ",
        },
        {
          id: 16,
          card: {
            transition: false,
            text:
              "Placing a legal hold will extend call retention beyond a predetermined retention policy timeline to ensure it is accessible in the event of litigation or other regulation scenarios. Any interaction without a hold will be automatically removed after the retention period.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "70.5%",
              x: "1.6%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "In the same view, the focus has shifted to the list of calls on the left-hand side of the screen. The user has clicked a check box next to the fourth call down on the list. ",
        },
        {
          id: 17,
          card: {
            transition: false,
            text: "Return to the Interaction Type",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "0.5%",
              x: "14.25%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image17.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked the check box next to the fourth call down the list, and a purple pop-up is pointing to an arrow above the call list.",
        },
        {
          id: 18,
          card: {
            transition: false,
            text:
              "Select “Chat” to search for, review, and export these interactions",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "38%",
              x: "1.15%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step2a_Image21.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked the arrow above the call list, and the list of calls has been replaced with a list of available filters. The “Interaction Type” filter has been expanded, and a purple pop-up points to “Chat”",
        },
        {
          id: 18,
          card: {
            transition: false,
            text:
              "Identify the conversation you would like to examine and export the data as XML, CSV, or JSON files",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "9.4%",
              x: "18.35%",
            },
            beacon: {
              isVisible: true,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image22.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked “Chat”, and now a list of chat interactions has appeared on the right has side of the screen. A purple pop-up points to the first chat in the list. ",
        },
        {
          id: 19,
          card: {
            transition: false,
            text:
              "These compliance management features are also applicable to voice, screen sharing, and email interactions across desktop and mobile devices, ensuring your business maintains a comprehensive communications record.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "72%",
              x: "18.35%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step2a_Image23.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
            sequenceSources: [],
          },
          screenReaderText:
            "The user has clicked on the first chat, and the view has changed. Now the list of chats is on the left side of the screen, and details of the selected chat are displayed on the right. ",
        },
      ],
    },
    {
      id: 3,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Monitor alarms in the NICE COMPASS Portal",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3_Image0.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "Compass Alarms aggregate alerts for compliance officers with an interface that's simple to filter and manage.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "82%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image1a.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "There’s a vertically oriented list of calls on the left side of the screen, and details of a selected call from the list displayed on the right. ",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "Click the menu icon to navigate to the Alarms tab in the applications toolbar",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "0.5%",
              x: "0.1%",
            },
            beacon: {
              isVisible: true,
              position: "top-left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image1b.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to a menu icon above the list of chats. ",
        },
        {
          id: 3,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "8%",
              x: "0.6%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image2.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the menu icon, and a vertically oriented bar has appeared to the left of the call list. A purple pop-up points to an icon that reads “Alarms”. ",
        },
        {
          id: 4,
          card: {
            transition: false,
            text: "View all alarms in the main screen",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "18%",
              x: "50%",
            },
            beacon: {
              isVisible: false,
              position: "top",
            },
          },
          images: {
            name: ["NICE_Step3a_Image3.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the “Alarms” icon, and the view has changed to display a list of alarms. The list of alarms is outlined in a purple box. ",
        },
        {
          id: 5,
          card: {
            transition: false,
            text: "Filter alarms by number, level, or alarm status",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "11.4%",
              x: "3.35%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image4.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the purple box is gone, and a purple pop-up points to a drop down that filters the list by alarm number. The vertical list reads “All, 6410, 6411, 4003” top to bottom. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "11.4%",
              x: "14.8%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image5.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the purple pop-up has switched to a dropdown to the right that filters the alarm by “Level”. The vertical list reads “All, Error, Fatal, Warning” top to bottom. ",
        },
        {
          id: 6,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "11.4%",
              x: "21.2%",
            },
            beacon: {
              isVisible: true,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image6.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the purple pop-up switched to a dropdown to the right that filters the list by “Alarm status”. The vertical list reads “All, Cleared, Raised” top to bottom. ",
        },
        {
          id: 7,
          card: {
            transition: false,
            text:
              "Alarms are categorized by levels, including Warning, Error, and Fatal, to help compliance officers triage concerns.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "81%",
              x: "14.8%",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step3a_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, there are no filters listed. The list of alarms is displayed. ",
        },
        {
          id: 8,
          card: {
            transition: false,
            text: "Click on the info icon to view details about the alarm",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "13.5%",
              x: "95.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image7.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, a purple pop-up points to an info icon to the right of the first alarm on the list. ",
        },
        {
          id: 9,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "13.5%",
              x: "95.7%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image9.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the user has clicked the info icon. A small box has appeared in the center of the screen with the alarm information. ",
        },
        {
          id: 10,
          card: {
            transition: false,
            text:
              "Technical or operations teams must take action on alarms with level Error and Fatal, and can clear Warning without taking action.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "95.7%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image10.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the box with the alarm information has disappeared, and a purple box outlines the list of alarms. ",
        },
        {
          id: 11,
          card: {
            transition: false,
            text:
              "Export the list of alarms to a CSV file by clicking the CSV icon",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "7.1%",
              x: "96.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The purple box outlining the alarm list has disappeared. There’s a purple pop-up pointing to a CSV icon in the upper right-hand corner of the screen. ",
        },
        {
          id: 12,
          card: {
            transition: false,
            text:
              "Click on the magnifying glass icon to mark the alarm as Attended",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "13.5%",
              x: "96.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the pop-up is now pointed to a magnifying glass icon to the right of the first alarm on the list.",
        },
        {
          id: 13,
          card: {
            transition: false,
            text:
              "Clear alarms that have the status Attended by selecting the Clear Alarms button and confirming clearing",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "7.3%",
              x: "86.7%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image11.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "In the same view, the pop-up is pointing to a check box in the upper right-hand corner that reads “clear alarms”",
        },
        {
          id: 14,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "52.3%",
              x: "48.4%",
            },
            beacon: {
              isVisible: true,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image14.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked the “clear alarms” box, and a notification has popped into the middle of the screen that reads “Please confirm that you want to clear the alarms” with two buttons that read “okay” and “cancel”. A purple pop-up points to the “okay” button. ",
        },
        {
          id: 15,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "left",
            },
            position: {
              y: "52.3%",
              x: "48.4%",
            },
            beacon: {
              isVisible: false,
              position: "right",
            },
          },
          images: {
            name: ["NICE_Step3a_Image15.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The user has clicked “okay” on the notification, and the view has returned to the list of alarms. A purple box outlines the alarm status, they all read “Cleared”.  ",
        },
      ],
    },
    {
      id: 4,
      sections: [
        {
          id: 0,
          card: {
            transition: true,
            text: "Get started with NICE Compliance Recording in Teams",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step5_end_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 1,
          card: {
            transition: false,
            text:
              "When your organization is ready to deploy the NICE Compliance Recording solution, collaborate with the NICE integration team to configure setup.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step4a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText:
            "The view has returned to the chat window, with the thread between Megan Bowen and Nestor Wilke. Megan’s message reads “Hi Nestor! Do you have time for a quick call to debrief on that last meeting?” Nestor replies “Sure, go head and give me a call.”",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "IT admin can customize retention policies and regulated users to meet the needs of your business.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step4a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText: "",
        },
        {
          id: 2,
          card: {
            transition: false,
            text:
              "With the integration complete, you are ready to begin recording communications in Teams.",
            snack: {
              isVisible: true,
              position: "left",
            },
            position: {
              y: "80%",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step4a_Image1.jpg"],
            imageAltText: "Screenshot of Microsoft Teams desktop interface",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
    {
      id: 5,
      sections: [
        {
          id: 0,
          card: {
            transition: false,
            text: "",
            snack: {
              isVisible: false,
              position: "right",
            },
            position: {
              y: "0",
              x: "0",
            },
            beacon: {
              isVisible: false,
              position: "left",
            },
          },
          images: {
            name: ["NICE_Step5_end_card.jpg"],
            imageAltText: "",
            sequence: false,
          },
          screenReaderText: "",
        },
      ],
    },
  ],
};
